import { CrudService } from './crud.service';
import { CarResource as Res } from '@shared/resources/car';
import { CarCreateUpdateDto as DTO } from '@shared/dto/car';

export class CarService extends CrudService<DTO, DTO, Res> {
  protected pathPrefix(): string {
    return 'cars';
  }
}
